import create, { SetState, StateCreator, StoreApi } from "zustand";

interface IModaldata {
  title: string,
  data: any[],
  columnData: any[],
  rowData: any,
}
interface IHospitalMappingStore {
  pageCurrentMode: string;
  setPageCurrentMode: (x: string) => void;
  isFacilityEditing: boolean;
  setIsFacilityEditing: (x: boolean) => void;
  activeTab: string;
  setActiveTab: (x: string) => void;
  isAddTableRowModalOpen: boolean;
  setIsAddTableRowModalOpen: (x: boolean) => void;
  activeTabName: string;
  setActiveTabName: (x: string) => void;
  isAddTableRowModalSaveDisabled: boolean;
  setisAddTableRowModalSaveDisabled: (x: boolean) => void;
  selectedFacility: any;
  setSelectedFacility: (x: any) => void;
  isHospitalListLoading: boolean;
  setIsHospitalListLoading: (x: boolean) => void;
  hospitalListTabData: any;
  setHospitalListTabData: (x: any) => void;
  hospitalListTabColumnConfig: any;
  setHospitalListTabColumnConfig: (x: any) => void;
  isHospitalListTabColumnConfigLoaded: boolean;
  setIsHospitalListTabColumnConfigLoaded: (x: boolean) => void;
  modalData: IModaldata;
  setModalData: (x: IModaldata) => void;
  modalMode: string,
  setModalMode: (x: string) => void;
  isBackButtonDisplay: boolean;
  setIsBackButtonDisplay: (x: boolean) => void; 
  showHospitalistsModal: boolean;
  setShowHospitalistsModal: (x: boolean) => void; 
  isFacilityUpdated: boolean;
  setIsFacilityUpdated: (x: boolean) => void; 
  availableFacilityOfCurrentMember: string[];
  setAvailableFacilityOfCurrentMember: (x: string[]) => void; 
  hospitalMappingEditModeOpenedFrom: number,
  setHospitalMappingEditModeOpenedFrom: (x: number) => void;
  clearStore: () => void;
  showMemberDetailsModal: boolean; 
  setShowMemberDetailsModal: (x: boolean) => void;
}

export enum pageMode {
  readMode = "read",
  editMode = "edit",
}

let store: StateCreator<IHospitalMappingStore, [], [], IHospitalMappingStore> | StoreApi<IHospitalMappingStore> = (set: SetState<IHospitalMappingStore>) => ({
  pageCurrentMode: pageMode.readMode,
  setPageCurrentMode: (x) => {
    set((state) => ({ pageCurrentMode: x }));
  },
  isFacilityEditing: true,
  setIsFacilityEditing: (x) => {
    set((state) => ({ isFacilityEditing: x }));
  },
  activeTab: "1",
  setActiveTab: (x) => {
    set((state) => ({ activeTab: x }));
  },
  isAddTableRowModalOpen: false,
  setIsAddTableRowModalOpen: (x) => {
    set((state) => ({ isAddTableRowModalOpen: x }));
  },
  activeTabName: "",
  setActiveTabName: (x) => {
    set((state) => ({ activeTabName: x }));
  },
  isAddTableRowModalSaveDisabled: true,

  setisAddTableRowModalSaveDisabled: (x) => {
    set((state) => ({ isAddTableRowModalSaveDisabled: x }));
  },

  selectedFacility : {},
  setSelectedFacility: (x) => {
    set((state) => ({ selectedFacility: x }));
  }, 

  isHospitalListLoading : true,
  setIsHospitalListLoading: (x) => {
    set((state) => ({ isHospitalListLoading: x }));
  },

  hospitalListTabData : {},
  setHospitalListTabData : (x) => {
    set((state) => ({ hospitalListTabData: x }));
  },

  hospitalListTabColumnConfig : {},
  setHospitalListTabColumnConfig : (x) => {
    set((state) => ({ hospitalListTabColumnConfig: x }));
  },
  isHospitalListTabColumnConfigLoaded : true,
  setIsHospitalListTabColumnConfigLoaded: (x) => {
    set((state) => ({ isHospitalListTabColumnConfigLoaded: x }));
  },
  modalData: { 
    title: "",
    data: [],
    columnData: [],
    rowData: [],
  },
  setModalData: (x: IModaldata) => {
    set((state) => ({ modalData: x }));
  },
  modalMode: "",
  setModalMode: (x: string) => {
    set((state) => ({ modalMode: x }));
  },
  isBackButtonDisplay: false,
  setIsBackButtonDisplay: (x: boolean) => {
    set((state) => ({ isBackButtonDisplay: x }));
  },
  showHospitalistsModal: false,
  setShowHospitalistsModal: (x: boolean) => {
    set((state) => ({ showHospitalistsModal: x }));
  },
  showMemberDetailsModal: false, 
  setShowMemberDetailsModal: (x: boolean) => {
    set((state) => ({ showMemberDetailsModal: x }));
  },
  isFacilityUpdated: false,
  setIsFacilityUpdated: (x: boolean) => {
    set((state) => ({ isFacilityUpdated: x }));
  },
  availableFacilityOfCurrentMember: [],
  setAvailableFacilityOfCurrentMember: (x: string[]) => {
    set((state) => ({ availableFacilityOfCurrentMember: x }));
  },
  hospitalMappingEditModeOpenedFrom: 0,
  setHospitalMappingEditModeOpenedFrom: (x: number) => {
    set((state) => ({ hospitalMappingEditModeOpenedFrom: x }));
  },

  clearStore: () => {
    set(() => ({ pageCurrentMode: pageMode.readMode }));
    set(() => ({ isFacilityEditing: true }));
    set(() => ({ activeTab: "1" }));
    set(() => ({ isAddTableRowModalOpen: false }));
    set(() => ({ activeTabName: undefined }));
    set(() => ({ isAddTableRowModalSaveDisabled: true }));
    set(() => ({ selectedFacility: {} }));
    set(() => ({ isHospitalListLoading: true }));
    set(() => ({ hospitalListTabData : {} }));
    set(() => ({ hospitalListTabColumnConfig: {} }));
    set(() => ({ modalData: {
      title: "",
      data: [],
      columnData: [],
      rowData: [],
    } }));
    set(() => ({ modalMode: "" }));
    set(() => ({ isBackButtonDisplay: false }));
    set(() => ({ showHospitalistsModal: false }));
    set(() => ({ isFacilityUpdated: false }));
    set(() => ({ availableFacilityOfCurrentMember:[] }));
    set(() => ({ isHospitalListTabColumnConfigLoaded: true }));
    set(() => ({ hospitalMappingEditModeOpenedFrom: 0 }));
    set(() => ({ showMemberDetailsModal: false }));
  },
});

export const useHospitalMappingStore = create(store);
